import { StateContext } from "@client/pages/round/Round";
import { useContext } from "react";

export function RoundTitle() {
  const { round } = useContext(StateContext);

  return (
    <div
      className="flex items-center fill-white text-xl leading-10 group"
      style={{ gridArea: "title" }}
    >
      {round.name}
    </div>
  );
}

export default RoundTitle;
